/**
 * Blog single: "copy link" share button with toast.
 */
document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('.js-copy-link');
    var toast = document.getElementById('copyLinkToast');
    if (!btn) return;

    function showToast(msg) {
        if (!toast) return;
        toast.textContent = msg;
        toast.classList.add('visible');
        setTimeout(function () { toast.classList.remove('visible'); }, 2000);
    }

    btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = this.getAttribute('data-url');
        if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(function () {
                showToast('Link copied!');
            });
        } else {
            var ta = document.createElement('textarea');
            ta.value = url;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            showToast('Link copied!');
        }
    });
});
